import {} from './money.js';
/** The effect a single classified outflow has on accumulated net worth. */
export function netWorthEffect(event) {
    switch (event.classification) {
        case 'consumptive':
            return -event.amount;
        case 'asset-converting':
        case 'debt-service':
            return 0; // neutral at the point of the transaction
    }
}
/**
 * Net-worth roll-forward (spec §2.1 / §2.3):
 *   ACCUMULATED(t) = ACCUMULATED(t-1) + budgetNet + Σ netWorthEffect(one-offs in t)
 * "Accumulated fortune bases itself off the budget"; one-offs layer on top.
 */
export function rollForward(input) {
    const points = [];
    let running = input.openingNetWorth;
    for (let m = 0; m < input.months; m++) {
        const monthEvents = input.events.filter((e) => e.month === m);
        const oneOffsEffect = monthEvents.reduce((sum, e) => sum + netWorthEffect(e), 0);
        running = running + input.monthlyBudgetNet + oneOffsEffect;
        points.push({ month: m, budgetNet: input.monthlyBudgetNet, oneOffsEffect, accumulated: running });
    }
    return points;
}
//# sourceMappingURL=networth.js.map